import { Outlet } from '@tanstack/react-router';

import { FeatureNotEnabledView } from 'common/components/cookbook/FeatureNotEnabledView/FeatureNotEnabledView';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

import { useFeatureFlagWithInventoryServiceEnabled } from '../common/hooks/useWarehouseFeatureEnabled';

const ProductAverageWeightEnabledRoute = () => {
  const f = useFormatMessage();
  const weightBaseSellingEnabled = useFeatureFlagWithInventoryServiceEnabled(
    'weight-base-selling-warehouse',
  );
  const viewTitle = f('product_average_weight.product_average_weight');

  if (weightBaseSellingEnabled) {
    return <Outlet />;
  }

  return (
    <FeatureNotEnabledView
      viewTitle={viewTitle}
      description={f('warehouse.common.feature_not_enabled')}
    />
  );
};

export default ProductAverageWeightEnabledRoute;
